// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.component-container {
  position: relative;
  overflow-x: hidden; /* Hide horizontal overflow, but allow vertical scrolling */
  margin-top: 2rem;
  /* The height of this container will be adjusted dynamically by the React component */
  /* This ensures the container is tall enough for the content and allows scrolling */
  transition: height 0.3s ease-in-out;
}

.component-slider {
  display: flex;
  /* The slider is twice the width of the container to hold both components */
  width: 200%;
  /* By default, show the component on the right (About Me) */
  transform: translateX(-50%);
  transition: transform 0.5s ease-in-out;
}

/* This class will be added to slide the container to the left, revealing the first component (Projects) */
.component-slider.show-projects {
  transform: translateX(0);
}

.component-wrapper {
  /* Each component wrapper takes up half of the slider's width */
  width: 50%;
  flex-shrink: 0;
  box-sizing: border-box;
  /* Add some padding so content isn't flush with the edges */
  padding: 0 15px;
}`, "",{"version":3,"sources":["webpack://./src/animations.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,2DAA2D;EAC/E,gBAAgB;EAChB,qFAAqF;EACrF,mFAAmF;EACnF,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,2EAA2E;EAC3E,WAAW;EACX,2DAA2D;EAC3D,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,0GAA0G;AAC1G;EACE,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;EAC/D,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,2DAA2D;EAC3D,eAAe;AACjB","sourcesContent":[".component-container {\n  position: relative;\n  overflow-x: hidden; /* Hide horizontal overflow, but allow vertical scrolling */\n  margin-top: 2rem;\n  /* The height of this container will be adjusted dynamically by the React component */\n  /* This ensures the container is tall enough for the content and allows scrolling */\n  transition: height 0.3s ease-in-out;\n}\n\n.component-slider {\n  display: flex;\n  /* The slider is twice the width of the container to hold both components */\n  width: 200%;\n  /* By default, show the component on the right (About Me) */\n  transform: translateX(-50%);\n  transition: transform 0.5s ease-in-out;\n}\n\n/* This class will be added to slide the container to the left, revealing the first component (Projects) */\n.component-slider.show-projects {\n  transform: translateX(0);\n}\n\n.component-wrapper {\n  /* Each component wrapper takes up half of the slider's width */\n  width: 50%;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  /* Add some padding so content isn't flush with the edges */\n  padding: 0 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
